import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCurrency$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCurrency extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1ba9f33928e1299f989b4f05b058d6c1585d579c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '846fcc6102cf4bd1940f0b77a4d68a3e635ffed8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0462aec2b7132e761da46a57047d8279ba047fb9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.495 4H19.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-9H5.495a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5M2.5 7.49h13.505a.5.5 0 0 1 .5.5v9.51a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5V7.99a.51.51 0 0 1 .5-.5m12.504 9.01H9.813v-1.08a1.63 1.63 0 0 0 1.59-1.6c0-.75-.39-1.16-1.45-1.59l-.69-.25c-.58-.22-.74-.36-.74-.67 0-.35.27-.56.73-.56.324-.03.63.157.75.46a.31.31 0 0 0 .28.22h.72c.17 0 .24-.11.21-.24a1.625 1.625 0 0 0-1.4-1.34v-.86h5.191zM8.672 8.99H3.501v7.51h5.171v-1.1a1.77 1.77 0 0 1-1.54-1.5c-.02-.13.04-.23.21-.23h.74c.136 0 .253.097.28.23a.876.876 0 0 0 .92.59c.56 0 .88-.22.88-.6 0-.35-.17-.51-.75-.71l-.66-.24c-1.01-.38-1.45-.86-1.45-1.6a1.53 1.53 0 0 1 1.37-1.49z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-currency", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-currency"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-currency":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCurrency$1);
            }
            break;
    } });
}

const CosmosIconCurrency = CosmosIconCurrency$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCurrency, defineCustomElement };
